import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { confirmDelete } from "../../utils/commonFunctions";
import { deleteAuthorAction, getAuthors } from "../../redux/actions/authorAction";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAuthors(setLoading));
    }, [dispatch]);

    let { allAuthors } = useSelector((state) => state.author);

    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState("");
    const getFilteredData = (data, search) => {
        if (search.length) {
            data = data.filter((item) => item?.name?.toLowerCase()?.includes(search) || item?.description?.toLowerCase()?.includes(search));
        }
        return data;
    };

    allAuthors = getFilteredData(allAuthors, search);

    const onDelete = (authorId, position) => {
        confirmDelete(
            () => {
                dispatch(deleteAuthorAction(authorId));
            },
            "Do you want to delete this Author?",
            position
        );
    };

    allAuthors = getFilteredData(allAuthors, search);
    return {
        allAuthors,
        loading,
        history,
        search,
        setSearch,
        onDelete,
    };
}
